import React, {useMemo} from 'react';
import {observer} from 'mobx-react';
import {formsStore} from '../../../stores/Form/FormsStore';
import {AutomationsModule} from '../modules/FormRules/FormAutomation.module';
import {MacroMenu} from '../../../_legacy/Macro/components/MacroMenu';
import {findFormByLevel} from '../../../stores/Form/utils';
import {getActiveFormsState} from '../../../_shared/GWTBridge/invoke/formTable';

export type Props = {
    automationMenu?: any;
    componentClasses?: string;
    macroSubmenu?: boolean;
};

export const AutomationRuleBridge = observer(
    ({automationMenu, macroSubmenu, componentClasses}: Props) => {
        const params = useMemo(() => new URLSearchParams(window.location.search), []);
        const showLegacyAutomations = params.get('_legacy-automations') === '1';
        const activeLevel = formsStore.currentScreen?.activeLevel;

        const currentForm = useMemo(() => {
            const level =
                typeof activeLevel === 'number' ? activeLevel : getActiveFormsState().length - 1;
            // we should find the active form in this way, cause showing any message on top of the automation dialog clears the currentLevel;
            const masterForm = formsStore.currentScreen?.form;

            if (masterForm) {
                return findFormByLevel(formsStore.currentScreen.form, level);
            }
            return null;
        }, [activeLevel]);

        if (!currentForm && showLegacyAutomations) {
            return <MacroMenu settingsItems={automationMenu} macroSubmenu={macroSubmenu} />;
        }

        return (
            <AutomationsModule
                form={currentForm}
                componentClasses={componentClasses}
                macroSubmenu={macroSubmenu}
            />
        );
    }
);
